import React from 'react';
import { motion } from 'framer-motion';
import { Zap, BookOpen, Award, Users } from 'lucide-react';
const problems = [{
  icon: Zap,
  title: '¿Sientes el llamado pero no sabes por dónde empezar?',
  description: 'Tienes intuición y sensibilidad energética, pero la información que encuentras es fragmentada y confusa.'
}, {
  icon: BookOpen,
  title: '¿Aprendes de aquí y de allá sin una estructura clara?',
  description: 'Cursos sueltos, videos de YouTube, grupos de Facebook... pero nada que te dé una formación sólida y progresiva.'
}, {
  icon: Award,
  title: '¿Quieres profesionalizar tu práctica pero no sabes cómo?',
  description: 'Sientes que podrías ayudar a otros, pero te falta el marco profesional para hacerlo con seguridad y confianza.'
}, {
  icon: Users,
  title: '¿No sabes cómo estructurar una sesión de principio a fin?',
  description: 'Conoces técnicas sueltas pero no tienes un protocolo claro para conducir sesiones efectivas y seguras.'
}];
export function ProblemSection() {
  return <section className="py-20 bg-[#1e1254] relative overflow-hidden" data-id="element-246">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-248">
          <motion.h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-249">
            ¿Te identificas con alguna de estas situaciones?
          </motion.h2>
          <motion.div className="h-1 w-24 bg-[#d4af37] mx-auto rounded-full" initial={{
          width: 0
        }} whileInView={{
          width: 96
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-250" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-251">
          {problems.map((problem, index) => <motion.div key={index} className="bg-[#0f0a2e]/50 border border-purple-800/50 p-8 rounded-lg hover:border-[#d4af37]/50 transition-all duration-300 group" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-252">
              <div className="mb-6 inline-block p-3 bg-[#d4af37]/10 rounded-full group-hover:bg-[#d4af37]/20 transition-colors" data-id="element-253">
                <problem.icon className="w-8 h-8 text-[#d4af37]" data-id="element-254" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-white font-heading leading-tight" data-id="element-255">
                {problem.title}
              </h3>
              <p className="text-purple-200 text-sm leading-relaxed" data-id="element-256">
                {problem.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div className="mt-16 text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-257">
          <p className="text-xl text-purple-100 font-light italic" data-id="element-258">
            Si respondiste{' '}
            <span className="text-[#d4af37] font-semibold" data-id="element-259">sí</span> a alguna de
            estas preguntas, el Sistema Profesional de Reiki fue diseñado
            exactamente para ti.
          </p>
        </motion.div>
      </div>
    </section>;
}